<script setup>
import { ref } from 'vue';

const emit = defineEmits(['send-message']);

defineProps({
  helpLink: {
    type: String,
    default: '',
  },
});

const message = ref('');

const handleSendMessage = () => {
  if (message.value.trim()) {
    emit('send-message', message.value);
    message.value = '';
  }
};
</script>

<template>
  <div :class="$style.footer">
    <div :class="$style.top">
      <XTextInput
        v-model="message"
        full-width
        :placeholder="$t('chatMessage.footer.input.placeholder')"
        data-testid="messageInput"
        @keyup.enter="handleSendMessage"
      />
      <XButton
        :class="$style.button"
        design="outlined"
        border-radius="circle"
        size="sm"
        data-testid="sendButton"
        @click="handleSendMessage"
      >
        <XIcon icon="arrow-up" />
      </XButton>
    </div>
    <div :class="$style.help">
      {{ $t('chatMessage.footer.help.text') }}
      <XLink
        icon="external-link"
        icon-position="right"
        no-padding
        small
        external
        target="_blank"
        :to="helpLink"
      >
        {{ $t('chatMessage.footer.help.link') }}
      </XLink>
    </div>
  </div>
</template>

<style lang="scss" module>
.footer {
  .top {
    display: flex;
    align-items: center;
    margin-bottom: var(--space-small-xx);
    gap: var(--space-small-xx);

    .button {
      flex-shrink: 0;
    }
  }

  .help {
    font-size: var(--font-size-small-x);
    text-align: center;
    color: var(--color-neutral-700);
  }
}
</style>
